export const TIME_OFF_MODAL_DELETE_TIME_OFF = 'TIME_OFF_MODAL_DELETE_TIME_OFF';
export const TIME_OFF_MODAL_DELETE_TIME_OFF_IN_PROGRESS =
  'TIME_OFF_MODAL_DELETE_TIME_OFF_IN_PROGRESS';
